var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('strong',[_vm._v(_vm._s(_vm.week.name))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.weekStartTime)+" - "+_vm._s(_vm.weekEndTime))])])}
var staticRenderFns = []

export { render, staticRenderFns }